import React, { useContext, useEffect, useState } from 'react';

import utils from '../../../services/utils';
import DetailInvoiceFields from '../DetailInvoiceFields/DetailInvoiceFields';
import BankAccounts from '../DetailsPayProcess/BankAccounts/BankAccounts';
import InfoPay from './InfoPay/InfoPay';
import apiMethods from '../../../apis';
import useGet from '../../../services/hooks/http/useGet';
import Context from '../../../store/context';
import DetailPaymentHistory from '../DetailPaymentHistory/DetailPaymentHistory';

import classes from './InvoicePayedProcessDetails.module.scss';

const InvoicePayedProcessDetails = ({ invoice, supplier, isProcess }) => {
  const [fetchVoucher, setFetchVoucher] = useState({ fetch: false, purchaseId: '', paymentId: '' });

  const {
    isSuccess: getPayedVoucherSuccess,
    data: getPayedVoucher,
    isError: getPayedVoucherError,
    errorMessage
  } = useGet(apiMethods.getPurchasePayoutVoucher, [fetchVoucher.purchaseId, fetchVoucher.paymentId], fetchVoucher.fetch);

  const {
    modal: { showError }
  } = useContext(Context);

  const [current, setCurrent] = useState({ view: 0, payment: {} });

  const showDetail = payment => {
    setCurrent({ view: 1, payment });
  };

  const backView = () => {
    setCurrent({ view: 0, payment: {} });
  };

  const downloadFile = () => {
    setFetchVoucher({ fetch: true, purchaseId: invoice.purchaseId, paymentId: current.payment.paymentId });
  };

  useEffect(() => {
    if (getPayedVoucherSuccess) {
      setFetchVoucher({ fetch: false, purchaseId: '', paymentId: '' });
      utils.downloadFileByUrl(getPayedVoucher);
    } else if (getPayedVoucherError) {
      showError({ title: 'Descargar comprobante', description: errorMessage });
    }
  }, [errorMessage, getPayedVoucher, getPayedVoucherError, getPayedVoucherSuccess, showError]);

  return (
    <div>
      {current.view === 0 ? (
        <div>
          <span className='bold-20'>{isProcess ? 'Detalles de cuenta de cobro en proceso' : 'Detalles de cuenta de cobro pagada'}</span>
          <div className={classes.cards}>
            <DetailInvoiceFields invoice={invoice} supplier={supplier} showDetailPay={showDetail} />
          </div>
          <div className={classes.cards}>
            <InfoPay invoice={invoice} isProcess={isProcess} />
          </div>
          <div className={classes.cards}>
            <BankAccounts accountsBanks={invoice} />
          </div>
        </div>
      ) : (
        <DetailPaymentHistory backView={backView} downloadFile={downloadFile} payment={current.payment} />
      )}
    </div>
  );
};

export default InvoicePayedProcessDetails;
